import { ReactElement } from 'react';
import loader1 from '../../static/loader-1.svg';
import loader2 from '../../static/loader-2.svg';
import loader3 from '../../static/loader-3.svg';

import AiSummaryAnimatedText from '../BillView/AiSummaryAnimatedText';

export enum Loading {
  billSummaries = 'bill-summaries',
  congressBillSummaries = 'congress-bill-summaries',
  billSearch = 'bill-search',
}

const AnalyzerLoadingAnimation = (props: {
  loading?: Loading;
  message?: string;
}): ReactElement => {
  const { loading, message } = props;

  return (
    <>
      <div id="analyzer-loader">
        <img id="l3" src={loader1} />
        <img id="l2" src={loader2} />
        <img id="l1" src={loader3} />
        <span className="analyzing-text">{message ?? 'Analyzing bill'}</span>
      </div>

      <AiSummaryAnimatedText loading={loading} />
    </>
  );
};

export default AnalyzerLoadingAnimation;
